import {
  ACQUISITION_DETAIL_BIDDABLE_LIST,
  ACQUISITION_DETAIL_BIDDABLE_LIST_SUCCESS,
  ACQUISITION_DETAIL_BIDDABLE_LIST_ERROR,
  ACQUISITION_DETAIL_BIDDABLE_PAGE_SET,
  ACQUISITION_DETAIL_BIDDABLE_ADD,
  ACQUISITION_DETAIL_BIDDABLE_ADD_SUCCESS,
  ACQUISITION_DETAIL_BIDDABLE_ADD_ERROR,
  ACQUISITION_DETAIL_BIDDABLE_ADD_CHANGE,
  ACQUISITION_DETAIL_BIDDABLE_UPDATE,
  ACQUISITION_DETAIL_BIDDABLE_UPDATE_SUCCESS,
  ACQUISITION_DETAIL_BIDDABLE_UPDATE_ERROR,
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: {
    header: { name: 'code', order: 'sorted-asc' },
    page: { current: 1, rows: 1000 },
    data: [],
    total_pages: 1,
  },
  add: { data: { new: { code: '', name: '', id_product: '', id_parent: '', id_acquisition_detail_type: '', id_acquisition: '' } }, loading: false, message: '' },
  edit: { update: { loading: false, response: '', message: '' } },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ACQUISITION_DETAIL_BIDDABLE_LIST:
      return { ...state, loading: true };
    case ACQUISITION_DETAIL_BIDDABLE_LIST_SUCCESS:
      return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case ACQUISITION_DETAIL_BIDDABLE_LIST_ERROR:
      return { ...state, loading: false, error: true };
    case ACQUISITION_DETAIL_BIDDABLE_PAGE_SET:
      return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case ACQUISITION_DETAIL_BIDDABLE_ADD_CHANGE:
      return { ...state, add: { ...state.add, data: { ...state.add.data, new: { ...state.add.data.new, ...action.payload } } } };
    case ACQUISITION_DETAIL_BIDDABLE_ADD:
      return { ...state, add: { ...state.add, loading: true } };
    case ACQUISITION_DETAIL_BIDDABLE_ADD_SUCCESS:
      return { ...state, add: { ...state.add, loading: false, message: action.payload.message, data: { new: { code: '', name: '', id_product: '', id_parent: '', id_acquisition_detail_type: '', id_acquisition: '' } } } };
    case ACQUISITION_DETAIL_BIDDABLE_ADD_ERROR:
      return { ...state, add: { ...state.add, loading: false, message: action.payload.message } };
    case ACQUISITION_DETAIL_BIDDABLE_UPDATE:
      return { ...state, edit: { ...state.edit, update: { loading: true, response: '', message: '' } } };
    case ACQUISITION_DETAIL_BIDDABLE_UPDATE_SUCCESS:
      return { ...state, edit: { ...state.edit, update: { loading: false, response: 'success', message: action.payload } } };
    case ACQUISITION_DETAIL_BIDDABLE_UPDATE_ERROR:
      return { ...state, edit: { ...state.edit, update: { loading: false, response: 'error', message: action.payload } } };
    default:
      return { ...state };
  }
};
